import React from 'react'
import Container from 'react-bootstrap/Container';

import Col from 'react-bootstrap/Col';
import solutions from '../Assets/Solutions_Img.png';
function Solutions() {
  const AIDriven = [
    { id: 1, text: "Automated Matching with AI & Machine Learning", completed: true },
    { id: 2, text: "Skill-Based Screening", completed: true },
    { id: 3, text: "Real-Time Insights & Analytics", completed: true },

  ];

  const AIPowered = [
    { id: 1, text: "Predictive Modeling for Drug Discovery", completed: true },
    { id: 2, text: "AI-Driven Molecular Analysis", completed: true },
    { id: 3, text: "Smart Data Integration for Clinical Trials", completed: true },

  ];

  const Pharma = [
    { id: 1, text: "AI-Enhanced Regulatory Reporting", completed: true },
    { id: 2, text: "Risk Management & Compliance Audits", completed: true },
    { id: 3, text: "Digital Record-Keeping & Compliance Automation", completed: true },

  ];
  return (
    <Container fluid className='m-0 p-0' >

      <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
        <Container>


          <h2 class="text-white pt-3">Solutions</h2>



        </Container>

      </div>

      <Container>

        <div class="row mt-4">
          <div class=" col-md-4">

            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} className=" p-3 "> {/* xs={12} makes it full width on small screens */}
              <h3 style={{ color: '#025EA9' }}>AI Recruitment Platform</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0' >
                  {AIDriven.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} className=" p-3  mt-3" > {/* xs={12} makes it full width on small screens */}
              <h3 style={{ color: '#025EA9' }}>AI-Powered Drug Research</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0'>
                  {AIPowered.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} className=" p-3  mt-3" > {/* xs={12} makes it full width on small screens */}
              <h3 style={{ color: '#025EA9' }}>Pharma Compliance Management</h3>
              <div className="item-list mt-4">
                <ul className='m-0 p-0'>
                  {Pharma.map(item => (
                    <li style={{ backgroundColor: 'transparent' }}
                      key={item.id}
                      className={item.completed ? 'completed' : 'incomplete'}
                    >
                      {item.completed && <i class="bi bi-check2-square tick-icon"></i>}
                      <span className="item-text"> {item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </div>
          <div class=" col-md-8"> <img src={solutions} alt='Employment Exchange' style={{ width: '80%' }} className='img-fluid' />  </div>
        </div>


      </Container>
      <div style={{ backgroundColor: '#025EA9' }} className='pt-5 pb-5 howitsworks-header-bg mt-4'>
        <Container>
          <h2 className='fw-bold text-center text-white mt-4'>How It Works</h2>

          <div class="steps pb-5">
            <div id="progress"></div>
            <div class="step-item">
              <button class="step-button text-center" type="button" data-toggle="collapse"
                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                1
              </button>
              <div class="step-title">
                Sign Up & Create <br />Profile
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                2
              </button>
              <div class="step-title">
                Post Jobs & <br />Requirements
              </div>
            </div>
            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                3
              </button>
              <div class="step-title">
                Match with AI-Powered <br />Recommendations
              </div>
            </div>

            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                4
              </button>
              <div class="step-title">
                Onboard Top-Tier <br />Pharma Talent
              </div>
            </div>


            <div class="step-item">
              <button class="step-button text-center collapsed" type="button" data-toggle="collapse"
                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                5
              </button>
              <div class="step-title">
                Scale Your Business <br />with AI Support
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Container>

  );


}

export default Solutions